import PropTypes from "prop-types";
import './Button.scss';

const Button = ({label, onClick}) => (
    <button className="button" onClick={onClick}>{label}</button>
);

Button.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func
};

export default Button;
